import React, { lazy } from 'react';
import { Trans } from '@lingui/macro';

const PayrollListPage = lazy(() =>
  import('./pages/list').then(module => ({
    default: module.PayrollListPage,
  })),
);

export const routes = [
  {
    path: '/hr/payroll-slips',
    component: PayrollListPage,
    navigation: {
      name: <Trans>Payroll Slips</Trans>,
      shortName: 'PS',
      onlyTopLevelLink: true,
    },
  },
];
